import styled from 'styled-components';

export const SocialLinksList = styled.ul`
  display: flex;
  opacity: 0.7;
  padding: var(--space-sm);
`;

export const SocialLinksItem = styled.li`  
  
  &:nth-child(2) {
    padding: 0 2vh;
  }

  &:hover a {
    border-radius: 0;
  }
`;

export const SocialLinksLink = styled.a`
  display: block;  
  border: 2px solid;
  border-radius: 50%;
  padding: 0.3rem;
  transition: all 50ms ease-in-out;
`;
